import { Injectable, SecurityContext, inject } from '@angular/core';
import { CoreHttpClient } from '@bepatient/core';
import { Observable, of, OperatorFunction, pipe } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { MyEdiary, MyEdiaryActivity } from './my-ediary-store.models';
import { RRule } from 'rrule';
import {
  addDays,
  addMonths,
  addWeeks,
  format,
  isAfter,
  isBefore,
  isFuture,
  isPast,
  isSameDay,
  isSameMonth,
  isSameWeek,
  isThisWeek,
  isToday,
  setDefaultOptions,
  subMonths,
  subWeeks
} from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
import { CommonUtilsService } from '@bepatient/common';

@Injectable()
export class MyEdiaryApiService {
  private http = inject(CoreHttpClient);
  private translate = inject(TranslateService);
  private utils = inject(CommonUtilsService);

  loadEDiary(): Observable<MyEdiary> {
    return this.http
      .get<any>('/rest/ediary', { withMobiCredentials: true })
      .pipe(this.eDiaryParser2());
  }

  // For mocking purposes
  loadeEDiary(): Observable<MyEdiary> {
    // Sample Data
    let rawData = {
      payload: [
        {
          id: '5639',
          title: 'AE Page - Repeat Mode',
          href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=5',
          type: 'activity-form',
          description: '',
          repeat_rule:
            'DTSTART:20230703T000000Z\r\nRRULE:FREQ=DAILY;UNTIL=20230730T000000Z',
          icon: '',
          color: '#1d639d',
          next_occurrence: 5,
          expiry_date: '18/07/2023 16:41',
          occurrences: [
            {
              date_created: '03/07/2023 16:41',
              date_completed: '',
              status: 3,
              can_edit: true,
              occurrence: '1',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=1'
            },
            {
              date_created: '06/07/2023 15:51',
              date_completed: '06/07/2023 15:51',
              status: 3,
              can_edit: true,
              occurrence: '2',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=2'
            },
            {
              date_created: '07/07/2023 14:56',
              date_completed: '07/07/2023 14:56',
              status: 3,
              can_edit: true,
              occurrence: '3',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=3'
            },
            {
              date_created: '10/07/2023 10:43',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '4',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=4'
            }
          ]
        },
        {
          id: '6257',
          title: 'AE Page - Repeat Mode #1',
          href: '',
          type: 'activity-form',
          description: '',
          repeat_rule:
            'DTSTART:20230626T000000Z\r\nRRULE:FREQ=ANYTIME;UNTIL=99991231T000000Z',
          icon: '',
          color: '#663333',
          next_occurrence: 7,
          expiry_date: '10/09/2023 16:41',
          occurrences: [
            {
              date_created: '10/07/2023 11:49',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '1',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=1'
            },
            {
              date_created: '17/07/2023 11:08',
              date_completed: '17/07/2023 11:09',
              status: 3,
              can_edit: false,
              occurrence: '2',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=2'
            },
            {
              date_created: '17/07/2023 11:10',
              date_completed: '17/07/2023 11:10',
              status: 3,
              can_edit: false,
              occurrence: '3',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=3'
            },
            {
              date_created: '17/07/2023 11:16',
              date_completed: '17/07/2023 11:16',
              status: 3,
              can_edit: false,
              occurrence: '4',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=4'
            },
            {
              date_created: '17/07/2023 11:37',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '5',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=5'
            },
            {
              date_created: '17/07/2023 11:38',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '6',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=6'
            }
          ]
        },
        {
          id: '5689',
          title: 'Meddra coding - Repeat Mode',
          href: '',
          type: 'activity-form',
          description: '',
          repeat_rule:
            'DTSTART:20230110T000000Z\r\nRRULE:FREQ=ANYTIME;UNTIL=20230703T000000Z',
          icon: '',
          color: '#FFCC00',
          next_occurrence: 1,
          expiry_date: '10/010/2023 16:41',
          occurrences: []
        },
        {
          id: '6299',
          title: 'Meddra coding - Repeat Mode #1',
          href: '',
          type: 'activity-form',
          description: '',
          repeat_rule:
            'DTSTART:20230626T000000Z\r\nRRULE:FREQ=ANYTIME;UNTIL=99991231T000000Z',
          icon: '',
          color: null,
          next_occurrence: 1,
          occurrences: []
        },
        {
          id: '6011',
          title: 'Epro Repeat event',
          href: '',
          type: 'activity-form',
          description: '',
          repeat_rule:
            'DTSTART:20220705T000000Z\r\nRRULE:FREQ=ANYTIME;UNTIL=99991231T000000Z',
          icon: '',
          color: '#1d639d',
          next_occurrence: 1,
          occurrences: []
        },
        {
          id: '5533',
          title: 'Repeat event page',
          href: '',
          type: 'activity-form',
          description: 'kkk',
          repeat_rule:
            'DTSTART:20221215T000000Z\r\nRRULE:FREQ=ANYTIME;UNTIL=99991231T000000Z',
          icon: '',
          color: '#CCCCFF',
          expiry_date: '',
          occurrences: [
            {
              date_created: '03/07/2023 16:43',
              date_completed: '17/07/2023 12:54',
              status: 3,
              can_edit: false,
              occurrence: '1',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=1'
            },
            {
              date_created: '03/07/2023 16:46',
              date_completed: '03/07/2023 16:49',
              status: 3,
              can_edit: false,
              occurrence: '2',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=2'
            },
            {
              date_created: '03/07/2023 16:53',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '3',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=3'
            },
            {
              date_created: '05/07/2023 11:02',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '4',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=4'
            },
            {
              date_created: '05/07/2023 12:12',
              date_completed: '',
              status: 2,
              can_edit: true,
              occurrence: '5',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=5'
            },
            {
              date_created: '17/07/2023 12:39',
              date_completed: '17/07/2023 12:39',
              status: 3,
              can_edit: false,
              occurrence: '6',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=6'
            },
            {
              date_created: '17/07/2023 12:40',
              date_completed: '17/07/2023 12:40',
              status: 3,
              can_edit: false,
              occurrence: '7',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=7'
            },
            {
              date_created: '17/07/2023 12:41',
              date_completed: '17/07/2023 12:42',
              status: 3,
              can_edit: false,
              occurrence: '8',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=8'
            },
            {
              date_created: '17/07/2023 12:46',
              date_completed: '17/07/2023 12:46',
              status: 3,
              can_edit: false,
              occurrence: '9',
              href: 'https://dev-smart-webservice.bepatientsolutions.com/rest/contents/forms/1214?occurrence=9'
            }
          ]
        }
      ],
      status: 200
    };

    // return this.http
    //   .get<any>('/rest/contents/forms/1214?occurrence=1', {
    //     withMobiCredentials: true
    //   })
    //   .pipe(switchMap(() => of(rawData).pipe(this.eDiaryParser2())));

    return of(rawData).pipe(this.eDiaryParser2());
  }

  private eDiaryParser(): OperatorFunction<any, any> {
    // Set start of the week on Monday and user Locale
    setDefaultOptions({ weekStartsOn: 1 });

    const getEdiary = (edata: any): MyEdiaryActivity[] => {
      let ediaries: any[];

      // Step 1: RRule Parser for each reoccurence activity
      let activities: Array<any> = [];
      edata &&
        edata.length &&
        edata.forEach((data, index) => {
          if (!data.repeat_rule) {
            return;
          }

          const validStatus = this.utils.validateRRule(data.repeat_rule);
          // If unable to parse the
          if (validStatus.code === 3) return;

          // Based on validStatus code format the RRule string to suitable format for parsing by RRule parser
          const validatedRRule = this.utils.formatRRule(
            data.repeat_rule,
            validStatus.code
          );

          // If RRule don't have reoccurrence end date,
          // Add end date 2 month from today to limit data
          // let rruleWithEndDate = data.repeat_rule;
          // if (!data.repeat_rule.includes('UNTIL')) {
          //   let rruleEndDate = format(addMonths(new Date(), 2), 'yyyyMMdd');
          //   rruleWithEndDate = data.repeat_rule + ';UNTIL=' + rruleEndDate;
          // }

          // let activityOccurrences = RRule.fromString(rruleWithEndDate).all();
          let activityOccurrences = RRule.fromString(validatedRRule).all();
          activityOccurrences.forEach((recurrenceDate, index) => {
            // occurrence Date by default generated 10:00:00 hour for 00:00:00 to override to midnight we force the hour to 00:00:00
            const occurrenceDate = new Date(
              recurrenceDate.getFullYear(),
              recurrenceDate.getMonth(),
              recurrenceDate.getDate(),
              0,
              0,
              0
            );
            if (occurrenceDate) {
              /**
               *  Status and Occurrence parser start
               */
              let itemStatus = 'status_early';
              let itemOccurrence;
              let itemHref;
              let foundActivity;

              data.occurrences &&
                data.occurrences.length > 0 &&
                data.occurrences.forEach(item => {
                  const itemDate = item.date && item.date.split('/');
                  if (itemDate) {
                    const itemFormattedDate = new Date(
                      itemDate[2],
                      itemDate[1] - 1, // in JS Date Month start from index 0 for Jan, 1 for Feb and so on.
                      itemDate[0]
                    );
                    const isStatusFound = isSameDay(
                      itemFormattedDate,
                      occurrenceDate
                    );
                    if (isStatusFound) {
                      foundActivity = item;
                      itemOccurrence = item.occurrence;
                      itemHref = item.href;
                      return;
                    }
                  }
                });

              if (foundActivity) {
                switch (foundActivity.status) {
                  case 0:
                    itemStatus = 'status_ready';
                    break;

                  case 1:
                    itemStatus = 'status_early';
                    break;

                  case 2:
                    itemStatus = 'status_ongoing';
                    break;

                  case 3:
                    itemStatus = 'status_completed';
                    break;

                  case 4:
                    itemStatus = 'status_outdated';
                    break;

                  default:
                    itemStatus = 'status_early';
                    break;
                }
              } else {
                // Activity Status not found
                // Is activity from past
                const pastActivity = isPast(occurrenceDate);
                if (pastActivity) itemStatus = 'status_outdated';

                // Is activity from today
                const currentActivity = isSameDay(new Date(), occurrenceDate);
                if (currentActivity) itemStatus = 'status_ready';

                // Is activity from future
                const futureActivity = isFuture(occurrenceDate);
                if (futureActivity) itemStatus = 'status_early';
              }
              /**
               *  Status and Occurrence parser End
               */

              // COMMENT REMOVE : NO NEEDED
              // ???? Insted of using occurrenceDate received we will convert it to new Date using the UTC to make the correct date time offset.
              // let myDate = new Date(occurrenceDate.getFullYear(), occurrenceDate.getMonth(), occurrenceDate.getDate(), occurrenceDate.getHours(), occurrenceDate.getMinutes(), occurrenceDate.getSeconds(), occurrenceDate.getMilliseconds());
              // let parsedUTCDate = new Date(myDate.getUTCFullYear(), myDate.getUTCMonth(), myDate.getUTCDate(), myDate.getUTCHours(), myDate.getUTCMinutes(), myDate.getUTCSeconds(), myDate.getUTCMilliseconds());
              // With data of occurrence date, status and other activity property create a array of activities.
              activities.push({
                ...data,
                title: data.title,
                ediary_date: occurrenceDate,
                year: format(occurrenceDate, 'yyyy'),
                month: format(occurrenceDate, 'MM'),
                month_name: format(occurrenceDate, 'MMM'),
                day: format(occurrenceDate, 'dd'),
                dayName: format(occurrenceDate, 'E'),
                activityTitle: '',
                status: itemStatus,
                href: itemHref || void 0,
                occurrence: itemOccurrence || void 0
              });
            }
          });
        });

      // Step 2: Group activity by month for each year
      let formatedActivities = [];
      let activeDate: Boolean = false;
      let setLastWeek: Boolean = false;
      let setThisWeek: Boolean = false;
      let setNextWeek: Boolean = false;
      let setPreviousMonth: Boolean = false;
      let setNextMonth: Boolean = false;
      let setLaterMonth: Boolean = false;
      activities.forEach((item, index) => {
        const currentDate = new Date();
        // Find the date on the activity list that is equal or greater than today, to scroll to that position.
        if (!activeDate) {
          activeDate =
            isToday(item.ediary_date) ||
            (format(currentDate, 'yyyy') === item.year &&
              format(currentDate, 'MM') === item.month &&
              format(currentDate, 'dd') <= item.day);
          item = {
            ...item,
            isActiveDay: activeDate
            // isToday: isToday(item.ediary_date)
          };
        }

        // Logic to set the previous month title for activity
        if (!setPreviousMonth) {
          const prevMonthString = subMonths(currentDate, 1);
          const isDatePreviousMonth = isSameMonth(
            item.ediary_date,
            prevMonthString
          );
          item = {
            ...item,
            activityTitle: isDatePreviousMonth
              ? this.translate.instant('TIME_SCHEDULE.PREVIOUS_MONTH')
              : item.activityTitle //'Previous Month'
          };
          setPreviousMonth = isDatePreviousMonth ? true : false;
        }

        // Logic to set the last week title for activity
        if (!setLastWeek) {
          const lastWeekTimeString = subWeeks(currentDate, 1);
          const isDateLastWeek = isSameWeek(
            lastWeekTimeString,
            item.ediary_date
          );
          item = {
            ...item,
            activityTitle: isDateLastWeek
              ? this.translate.instant('TIME_SCHEDULE.LAST_WEEK')
              : item.activityTitle
          };
          setLastWeek = isDateLastWeek ? true : false;
        }

        // Logic to set the this week title for activity
        if (!setThisWeek) {
          // const nextWeekTimeString = addWeeks(currentDate , 1);
          const isDateThisWeek = isThisWeek(item.ediary_date);
          item = {
            ...item,
            activityTitle: isDateThisWeek
              ? this.translate.instant('TIME_SCHEDULE.THIS_WEEK')
              : item.activityTitle
          };
          setThisWeek = isDateThisWeek ? true : false;
        }

        // Logic to set the next week title for activity
        if (!setNextWeek) {
          const nextWeekTimeString = addWeeks(currentDate, 1);
          const isDateNextWeek = isSameWeek(
            nextWeekTimeString,
            item.ediary_date
          );
          item = {
            ...item,
            activityTitle: isDateNextWeek
              ? this.translate.instant('TIME_SCHEDULE.NEXT_WEEK')
              : item.activityTitle
          };
          setNextWeek = isDateNextWeek ? true : false;
        }

        // Logic to set the next month title for activity
        if (!setNextMonth) {
          const nextMonthString = addMonths(currentDate, 1);
          const isDateNextMonth = isSameMonth(
            item.ediary_date,
            nextMonthString
          );
          item = {
            ...item,
            activityTitle: isDateNextMonth
              ? this.translate.instant('TIME_SCHEDULE.NEXT_MONTH')
              : item.activityTitle
          };
          setNextMonth = isDateNextMonth ? true : false;
        }

        // Logic to set the next month title for activity
        if (!setLaterMonth) {
          const laterMonthString = addMonths(currentDate, 2);
          const isDateLaterMonth = isSameMonth(
            item.ediary_date,
            laterMonthString
          );
          item = {
            ...item,
            activityTitle: isDateLaterMonth
              ? this.translate.instant('TIME_SCHEDULE.LATER')
              : item.activityTitle
          };
          setLaterMonth = isDateLaterMonth ? true : false;
        }
        // Check if formatted Activities object has activities for the month and year, if not create the new object for that particular month and year
        if (
          formatedActivities.length === 0 ||
          !formatedActivities.find(
            ({ year, month }) => year === item.year && month === item.month_name
          )
        ) {
          formatedActivities.push({
            year: item['year'],
            month: item['month_name'],
            monthNumber: item['month'],
            activityBlockTitle: '&nbsp; &nbsp;',
            monthData: []
          });
        }
        // Check the month and year object then add/push day data to particular day of that month and year.
        let findActivityByYearAndMonth =
          formatedActivities.find(
            ({ year, month }) => year === item.year && month === item.month_name
          ) || void 0;
        if (findActivityByYearAndMonth) {
          let monthYearDataIndex = formatedActivities.indexOf(
            findActivityByYearAndMonth
          );
          if (
            (formatedActivities[monthYearDataIndex] &&
              formatedActivities[monthYearDataIndex].monthData.length === 0) ||
            !formatedActivities[monthYearDataIndex].monthData.find(
              ({ day, dayName }) => day === item.day && dayName === item.dayName
            )
          ) {
            // If activity for particular day doesn't exists, then create the activity for that particular day.
            formatedActivities[monthYearDataIndex].monthData.push({
              day: item.day,
              dayName: item.dayName,
              dailyData: [item]
            });
          } else if (
            formatedActivities[monthYearDataIndex].monthData.find(
              ({ day, dayName }) => day === item.day && dayName === item.dayName
            )
          ) {
            // If activity for particular day exists, then push the activity into array for that particular day.
            let findDayOfMonth = formatedActivities[
              monthYearDataIndex
            ].monthData.find(
              ({ day, dayName }) => day === item.day && dayName === item.dayName
            );
            let dayDataIndex =
              formatedActivities[monthYearDataIndex].monthData.indexOf(
                findDayOfMonth
              );
            if (
              formatedActivities[monthYearDataIndex].monthData &&
              formatedActivities[monthYearDataIndex].monthData[dayDataIndex]
            ) {
              formatedActivities[monthYearDataIndex].monthData[
                dayDataIndex
              ].dailyData.push(item);
            }
          }

          // Sort the activities in ascending order of month days 01, 02, 03, 04
          formatedActivities[monthYearDataIndex].monthData = formatedActivities[
            monthYearDataIndex
          ].monthData.sort((a, b) => a.day - b.day);
        }
      });

      ediaries = formatedActivities;
      return (ediaries.length && ediaries) || void 0;
    };
    return pipe(
      map<any, MyEdiary>(data => ({
        activity: getEdiary(data.payload), // data.payload
        unformattedActivity: data.payload
      })),
      switchMap<MyEdiary, Observable<MyEdiary>>(eDiary => of(eDiary))
    );
  }

  private eDiaryParser2(): OperatorFunction<any, any> {
    // Set start of the week on Monday and user Locale
    setDefaultOptions({ weekStartsOn: 1 });
    let hasTodayFlag: Boolean = false;

    const getEdiary = (edata: any): MyEdiaryActivity[] => {
      let ediaries = [];

      // Step 1: RRule Parser for each reoccurence activity
      edata?.forEach((data: any) => {
        if (!data.repeat_rule) {
          return;
        }

        // Handling ANYTIME case,
        // In this case we cannot use the RRule, so we manually create activity based on
        // past occurrences array data and if next occurrence is present in the activity href property, we create activity for current day.
        if (data.repeat_rule.includes('ANYTIME')) {
          data.occurrences?.forEach((item: any) => {
            let activityDatePart = item?.date_created?.includes(' ')
              ? item?.date_created?.split(' ')[0]
              : item?.date_created;
            const itemDate = activityDatePart?.split('/');
            if (itemDate) {
              const itemFormattedDate = new Date(
                itemDate[2],
                itemDate[1] - 1, // in JS Date Month start from index 0 for Jan, 1 for Feb and so on.
                itemDate[0]
              );

              ediaries.push({
                ...data,
                title: data.title,
                ediary_date: itemFormattedDate,
                year: format(itemFormattedDate, 'yyyy'),
                month: format(itemFormattedDate, 'MM'),
                month_name: format(itemFormattedDate, 'MMM'),
                day: format(itemFormattedDate, 'dd'),
                dayName: format(itemFormattedDate, 'E'),
                activityTitle: '',
                nextActivityHasTitle: false,
                status: this.activityStatusParser(item.status),
                href: item.href || undefined,
                occurrence: item.occurrence || undefined,
                nextOccurrence: item.href || data.href || undefined
              });
            }
          });

          if (data.href) {
            const nextItemDate = new Date();
            ediaries.push({
              ...data,
              title: data.title,
              ediary_date: nextItemDate,
              year: format(nextItemDate, 'yyyy'),
              month: format(nextItemDate, 'MM'),
              month_name: format(nextItemDate, 'MMM'),
              day: format(nextItemDate, 'dd'),
              dayName: format(nextItemDate, 'E'),
              activityTitle: '',
              nextActivityHasTitle: false,
              status: this.activityStatusParser(0),
              href: data.href || undefined,
              occurrence: undefined,
              nextOccurrence: data.href || undefined
            });
          }
          return;
        }

        const validStatus = this.utils.validateRRule(data.repeat_rule);
        // If unable to parse the
        if (validStatus.code === 3) {
          return;
        }
        // Based on validStatus code format the RRule string to suitable format for parsing by RRule parser
        const validatedRRule = this.utils.formatRRule(
          data.repeat_rule,
          validStatus.code
        );

        let rruleString = RRule.fromString(validatedRRule);
        const startDate =
          this.checkAndGetStartDate(rruleString?.options?.dtstart) ||
          rruleString?.options?.dtstart ||
          new Date();
        let activityOccurrences = rruleString?.between(
          startDate,
          addMonths(new Date(), 2),
          true
        );
        if (!activityOccurrences) return;
        let remainingOccurrenceCount: number = 0;
        activityOccurrences.forEach((recurrenceDate: Date, index) => {
          // occurrence Date by default generated 10:00:00 hour for 00:00:00 to override to midnight we force the hour to 00:00:00
          const occurrenceDate = new Date(
            recurrenceDate.getFullYear(),
            recurrenceDate.getMonth(),
            recurrenceDate.getDate(),
            0,
            0,
            0
          );
          if (occurrenceDate) {
            // Logic for expiry date check goes here
            if (data?.expiry_date) {
              let expiryDatePart = data?.expiry_date?.includes(' ')
                ? data?.expiry_date?.split(' ')[0]
                : data?.expiry_date;

              // If not valid expiry date skip the item.
              if (
                !expiryDatePart ||
                (expiryDatePart && expiryDatePart.length !== 10)
              )
                return;

              const expiryDate = expiryDatePart?.split('/');
              const formattedExpiryDate = new Date(
                expiryDate[2],
                expiryDate[1] - 1, // in JS Date Month start from index 0 for Jan, 1 for Feb and so on.
                expiryDate[0]
              );
              // If the expiry date is on past, do not show rest of the activity
              if (
                formattedExpiryDate &&
                !isFuture(formattedExpiryDate) &&
                !isBefore(occurrenceDate, addDays(formattedExpiryDate, 1))
              )
                return;
            }

            // Logic to handle the case where there is limit in remaining occurrence from today date
            if (
              data?.remaining_occurrences &&
              data?.remaining_occurrences > 0 &&
              (isToday(occurrenceDate) || isFuture(occurrenceDate))
            ) {
              // If remainingOccurrenceCount from today is equal to the actual remaining_occurrences exit without creating more occurrences.
              if (remainingOccurrenceCount === data.remaining_occurrences)
                return;
              remainingOccurrenceCount++;
            }

            /**
             *  Status and Occurrence parser start
             */
            let itemStatus = 'status_early';
            let itemOccurrence;
            let itemHref;
            let foundActivity;

            data.occurrences?.forEach((item: any) => {
              const datePart = item?.date_created?.includes(' ')
                ? item?.date_created?.split(' ')[0]
                : item?.date_created;
              const itemDate = datePart?.split('/');
              if (itemDate) {
                const itemFormattedDate = new Date(
                  itemDate[2],
                  itemDate[1] - 1, // in JS Date Month start from index 0 for Jan, 1 for Feb and so on.
                  itemDate[0]
                );
                const isStatusFound = isSameDay(
                  itemFormattedDate,
                  occurrenceDate
                );
                if (isStatusFound) {
                  foundActivity = item;
                  itemOccurrence = item.occurrence;
                  itemHref = item.href;
                  return;
                }
              }
            });

            if (foundActivity) {
              itemStatus = this.activityStatusParser(foundActivity.status);
            } else {
              // Activity Status not found
              // Is activity from past
              const pastActivity = isPast(occurrenceDate);
              if (pastActivity) itemStatus = 'status_outdated';

              // Is activity from today
              const currentActivity = isSameDay(new Date(), occurrenceDate);
              if (currentActivity) itemStatus = 'status_ready';

              // Is activity from future
              const futureActivity = isFuture(occurrenceDate);
              if (futureActivity) itemStatus = 'status_early';
            }
            /**
             *  Status and Occurrence parser End
             */

            // In all the activities check if any activity match today
            if (!hasTodayFlag) {
              hasTodayFlag = isToday(occurrenceDate);
            }

            ediaries.push({
              ...data,
              title: data.title,
              ediary_date: occurrenceDate,
              year: format(occurrenceDate, 'yyyy'),
              month: format(occurrenceDate, 'MM'),
              month_name: format(occurrenceDate, 'MMM'),
              day: format(occurrenceDate, 'dd'),
              dayName: format(occurrenceDate, 'E'),
              activityTitle: undefined,
              nextActivityHasTitle: false,
              status: itemStatus,
              href: itemHref || undefined,
              occurrence: itemOccurrence || undefined,
              rruleOccurrenceIndex: index,
              nextOccurrence:
                (foundActivity ? foundActivity.href : data.href) || undefined
            });
          }
        });
      });

      // Sort all the generated activities of all ediary by their date
      ediaries = ediaries.sort((a, b) => {
        return a.ediary_date - b.ediary_date;
      });

      // Step 2: Group activity by month for each year
      let formatedActivities: any[] = [];
      let activeDate = false;
      let setToday = false;
      let setLastWeek = false;
      let setThisWeek = false;
      let setNextWeek = false;
      let setLaterWeek = false;
      let setPreviousMonth = false;
      let setThisMonth = false;
      let setNextMonth = false;
      let setLaterMonth = false;

      ediaries.forEach((item, index) => {
        const currentDate = new Date();
        // Find the date on the activity list that is equal or greater than today, to scroll to that position.
        if (!activeDate && hasTodayFlag) {
          activeDate = isToday(item.ediary_date);
          item.isActiveDay = activeDate;
        } else if (!activeDate && !hasTodayFlag) {
          activeDate =
            isToday(item.ediary_date) ||
            (format(currentDate, 'yyyy') === item.year &&
              format(currentDate, 'MM') === item.month &&
              (format(currentDate, 'dd') === item.day ||
                format(currentDate, 'dd') <= item.day));
          item.isActiveDay = activeDate;
        } else {
          item.isActiveDay = false;
        }

        // Logic to set the previous month title for activity
        if (!setPreviousMonth) {
          const prevMonthString = subMonths(currentDate, 1);
          const isDatePreviousMonth = isSameMonth(
            item.ediary_date,
            prevMonthString
          );
          item.activityTitle = isDatePreviousMonth
            ? this.translate.instant('TIME_SCHEDULE.PREVIOUS_MONTH')
            : item.activityTitle;
          setPreviousMonth = isDatePreviousMonth;
        }
        // Logic to set this month title for activity
        if (!setThisMonth) {
          const isDateThisMonth = isSameMonth(currentDate, item.ediary_date);
          item.activityTitle = isDateThisMonth
            ? this.translate.instant('TIME_SCHEDULE.CURRENT_MONTH')
            : item.activityTitle;
          setThisMonth = isDateThisMonth;
        }
        // Logic to set the last week title for activity
        if (!setLastWeek) {
          const lastWeekTimeString = subWeeks(currentDate, 1);
          const isDateLastWeek = isSameWeek(
            lastWeekTimeString,
            item.ediary_date
          );
          item.activityTitle = isDateLastWeek
            ? this.translate.instant('TIME_SCHEDULE.LAST_WEEK')
            : item.activityTitle;
          setLastWeek = isDateLastWeek;
        }
        // Logic to set the this week title for activity
        if (!setThisWeek) {
          const isDateThisWeek = isThisWeek(item.ediary_date);
          item.activityTitle = isDateThisWeek
            ? this.translate.instant('TIME_SCHEDULE.THIS_WEEK')
            : item.activityTitle;
          setThisWeek = isDateThisWeek;
        }
        // Logic to set the Today title for activity
        if (!setToday) {
          const todayTimeString = currentDate;
          const isDateToday = isSameDay(todayTimeString, item.ediary_date);
          item.activityTitle = isDateToday
            ? this.translate.instant('TIME_SCHEDULE.TODAY')
            : item.activityTitle;
          setToday = isDateToday;
        }
        // Logic to set the next week title for activity
        if (!setNextWeek) {
          const nextWeekTimeString = addWeeks(currentDate, 1);
          const isDateNextWeek = isSameWeek(
            nextWeekTimeString,
            item.ediary_date
          );
          item.activityTitle = isDateNextWeek
            ? this.translate.instant('TIME_SCHEDULE.NEXT_WEEK')
            : item.activityTitle;
          setNextWeek = isDateNextWeek;
        }
        // Logic to set the later week title for activity
        if (!setLaterWeek) {
          const laterWeekTimeString = addWeeks(currentDate, 2);
          const isDateLaterWeek = isSameWeek(
            laterWeekTimeString,
            item.ediary_date
          );
          item.activityTitle = isDateLaterWeek
            ? this.translate.instant('TIME_SCHEDULE.LATER')
            : item.activityTitle;
          setLaterWeek = isDateLaterWeek;
        }

        // Logic to set the next month title for activity
        if (!setNextMonth) {
          const nextMonthString = addMonths(currentDate, 1);
          const isDateNextMonth = isSameMonth(
            item.ediary_date,
            nextMonthString
          );
          item.activityTitle = isDateNextMonth
            ? this.translate.instant('TIME_SCHEDULE.NEXT_MONTH')
            : item.activityTitle;
          setNextMonth = isDateNextMonth;
        }
        // Logic to set the later month title for activity
        if (!setLaterMonth) {
          const laterMonthString = addMonths(currentDate, 2);
          const isDateLaterMonth =
            isSameMonth(item.ediary_date, laterMonthString) ||
            isAfter(item.ediary_date, laterMonthString);
          item.activityTitle = isDateLaterMonth
            ? this.translate.instant('TIME_SCHEDULE.LATER')
            : item.activityTitle;
          setLaterMonth = isDateLaterMonth;
        }

        if (item.activityTitle && index > 0) {
          ediaries[index - 1].nextActivityHasTitle = true;
        }
        // Check if formatted Activities object has activities for the month and year, if not create the new object for that particular month and year
        const monthYearData = formatedActivities.find(
          ({ year, month }) => year === item.year && month === item.month_name
        );

        if (!monthYearData) {
          formatedActivities.push({
            year: item.year,
            month: item.month_name,
            monthNumber: item.month,
            activityBlockTitle: '&nbsp; &nbsp;',
            monthData: [
              { day: item.day, dayName: item.dayName, dailyData: [item] }
            ]
          });
        } else {
          // If activity for particular day exists, then push the activity into array for that particular day.
          const dayData = monthYearData.monthData.find(
            ({ day, dayName }) => day === item.day && dayName === item.dayName
          );

          if (!dayData) {
            monthYearData.monthData.push({
              day: item.day,
              dayName: item.dayName,
              dailyData: [item]
            });
          } else {
            dayData.dailyData.push(item);
          }
          // Sort the activities in ascending order of month days 01, 02, 03, 04
          monthYearData.monthData.sort((a, b) => a.day - b.day);
        }
      });

      return formatedActivities.length
        ? this.activitySort(formatedActivities)
        : undefined;
    };

    return pipe(
      map<any, MyEdiary>(data => ({
        activity: getEdiary(data.payload),
        unformattedActivity: data.payload
      })),
      switchMap<MyEdiary, Observable<MyEdiary>>(eDiary => of(eDiary))
    );
  }

  /**
   * Sort all the activities by year and monthNumber
   * @param data
   * @returns
   */
  private activitySort(data) {
    return data.sort((a, b) => {
      // Compare the years
      const yearComparison = a.year.localeCompare(b.year);

      // If the years are the same, compare the monthNumbers
      if (yearComparison === 0) {
        return a.monthNumber.localeCompare(b.monthNumber);
      }

      // If the years are different, use the yearComparison result
      return yearComparison;
    });
  }

  private activityStatusParser(status: number): string {
    switch (status) {
      case 0:
        return 'status_ready';
      case 1:
        return 'status_early';
      case 2:
        return 'status_ongoing';
      case 3:
        return 'status_completed';
      case 4:
        return 'status_outdated';
      default:
        return 'status_early';
    }
  }

  /**
   * If the provided date is more than 5 month in the past return date(5 month earlier from today),
   * Else return the supplied date
   * @param date
   * @returns
   */
  private checkAndGetStartDate(date) {
    const today = new Date();
    const sixMonthsAgo = subMonths(today, 6); // Calculate date 5 months ago from today

    return isBefore(date, sixMonthsAgo) ? sixMonthsAgo : date;
  }
}
